const FinBankCreditScoreDashboardI18n = {
  tabs: {
    scoreResult: 'Score Result',
    scoreInfo: 'General Information',
  },
  loading: {
    fetchingScore: 'Loading score data...',
  },
  fetchError: 'Could not load score data. Please try again shortly.',
  error: {
    title: 'Error',
    missingDocument: 'The "document" property is required to query the score.',
    missingAuthCredentials: 'Provide either "tokenProvider" or "integratorToken" to authenticate the component.',
  },
  refreshDialog: {
    cancel: 'Cancel',
    confirm: 'Update information',
    withinLimit: {
      title: 'Important!',
      message: 'Updating this information will generate a new query with the credit partner, which will count toward your plan transactions.<br/><br/>Do you want to continue?',
    },
    limitReached: {
      title: 'Attention',
      message: 'The contracted query package has run out; if you proceed, an excess query charge will be generated.<br/><br/>Do you want to continue?',
    },
  },
};

export default FinBankCreditScoreDashboardI18n;
